// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rs-0";